<template>
  <div id="btnsWrap">
    <div class="frame-outer" :style="frameStyle">
      <div class="inr" @click.stop="onClick">次に進む</div>
      <div class="arrow" :style="arrowStyle"></div>
    </div>
  </div>
</template>

<script>
  import _$ from 'jquery'
  // import _ from 'lodash'

  export default {
    name: 'CorrectSet',
    props: {
    },
    data() {
      return {
        // publicPath: process.env.BASE_URL,
        frameStyle: {
          backgroundImage: 'url(./img/common/pink_frm02_522_t.png),url(./img/common/pink_frm02_522_b.png), url(./img/common/pink_frm02_l.png), url(./img/common/pink_frm02_r.png)'
        },
        arrowStyle: { backgroundImage: 'url(./img/common/white_arw.png)' },
        timer: null
      }
    },
    mounted() {
      this.blinkArrow()
    },
    destroyed() {
      this.stopTimer()
    },
    watch: {
    },
    methods: {
      onClick: function(){
        this.$emit('selectCorrect');
      },
      blinkArrow: function(){
        this.timer = setInterval(function(){
          _$('#btnsWrap .arrow').toggle()
        }.bind(this), 500)
      },
      stopTimer: function(){
        clearInterval(this.timer)
      }
    }
  }
</script>

<style lang="scss" scoped>
  #btnsWrap {
    height: toVW(320);
    margin: toVW(0) toVW(13) toVW(13);
    display: flex;
    align-items: center;

    .frame-outer {
      background-position: left top, left bottom, left top, right top;
      background-repeat: no-repeat, no-repeat, repeat-y, repeat-y;
      background-size: toVW(522) auto, toVW(522) auto, toVW(15) auto, toVW(15) auto;
      width: toVW(522);
      height: toVW(120);
      margin: 0 auto;
      position: relative;

      .inr {
        width: 100%;
        height: 100%;
        padding: toVW(40);
        text-align: center;
        line-height: 1.5;
        letter-spacing: .07em;
      }

      .arrow {
        background-repeat: no-repeat;
        background-size: contain;
        width: toVW(21);
        height: toVW(28);
        position: absolute;
        top: calc((100% - 3.733vw) / 2);
        left: toVW(37);
        display: none;
      }
    }
  }
</style>
